<template>
    <div class="mt-3 mb-4">
        <img src="@/assets/register/tanachat-logo.png" class="mx-auto h-45px" alt=""/>
    </div>
    <div class="flex items-center justify-center">
        <img v-show="currentStep == 0" src="@/assets/register/stepper-1.svg" v-cloak alt="step 1" class="w-full mx-8" />
        <img v-show="currentStep == 1" src="@/assets/register/stepper-2.svg" v-cloak alt="step 2" class="w-full mx-8" />
        <img v-show="currentStep == 2" src="@/assets/register/stepper-3.svg" v-cloak alt="step 3" class="w-full mx-8" />
    </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        currentStep: {
            type: Number,
            default: 0
        }
    },
})
</script>

<style lang="scss" scoped>
.indicator {
    @apply h-6 w-6 bg-a-gray-dedede rounded-full;

    &.active {
        @apply bg-a-orange-f36e21;
    }
}
</style>
